import * as Yup from "yup";

// ----------------------------------------------------------------------

export const ChallengeSuggestionSchema = Yup.object().shape({});
